import { Component } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

import { PageHeaderComponent, PageHeaderTitleComponent } from '@ciphr/shared/page-header';
import { PageNotFoundComponent } from '@ciphr/shared/page-not-found';

@Component({
  standalone: true,
  imports: [TranslocoDirective, PageHeaderComponent, PageHeaderTitleComponent, PageNotFoundComponent],
  template: `
    <ciphr-page-not-found>
      <ciphr-page-header />
      <ciphr-page-header-title *transloco="let t">{{ t('COMMON.PAGE_NOT_FOUND.HEADER') }}</ciphr-page-header-title>
    </ciphr-page-not-found>
  `,
  styles: [':host { height: 100vh; }'],
})
export default class AppPageNotFoundComponent {}
